import * as React from 'react';
import ParseHtml from 'html-react-parser';
import styled from 'styled-components';
import ContentConstants from '../../contentConstants';

export const NoSearchResultsMessageWrapper = styled.div.attrs<{ textAlign?: 'center' | 'left' | 'right' }>({
	className: 'tws-no-results-message',
})<{ textAlign?: 'center' | 'left' | 'right' }>`
	 {
		text-align: ${(props) => (props.textAlign ? props.textAlign : 'center')};
		padding-top: 50px;
		padding-bottom: 50px;
	}
`;
NoSearchResultsMessageWrapper.displayName = 'NoSearchResultsMessageWrapper';

export interface INoSearchResultsMessageProps {
	message?: string;
	textAlign?: 'center' | 'left' | 'right';
}

export class NoSearchResultsMessage extends React.Component<INoSearchResultsMessageProps> {
	public render() {
		return (
			<NoSearchResultsMessageWrapper textAlign={this.props.textAlign}>
				{this.props.message ? ParseHtml(this.props.message) : ContentConstants.SEARCH_NO_RESULTS_MESSAGE}
			</NoSearchResultsMessageWrapper>
		);
	}
}
